import { SummaryActionType, SummaryAction } from '../actions/SummaryActions';
import { PackageSummaryPerson } from '../types/api/enrollmentPackages/PackageSummaryPerson';
import { PackageSummaryPolicy } from '../types/api/enrollmentPackages/PackageSummaryPolicy';
import { Nullable } from '../types/custom/Nullable';

export interface SummaryState {
    summaryPeople: {
        data: Nullable<readonly PackageSummaryPerson[]>;
        loading: boolean;
        error: unknown;
    },
    summaryPolicies: {
        data: Nullable<readonly PackageSummaryPolicy[]>;
        loading: boolean;
        error: unknown;
    }
}

const INITIAL_STATE: SummaryState = {
    summaryPeople: {
        data: null,
        error: false,
        loading: false
    },
    summaryPolicies: {
        data: null,
        error: false,
        loading: false
    }
};

export default function (state = INITIAL_STATE, action: SummaryAction) {
    switch (action.type) {
        case SummaryActionType.FETCH_SUMMARY_PEOPLE:
            return {
                ...state,
                summaryPeople: {
                    data: null,
                    error: null,
                    loading: true
                }
            };
        case SummaryActionType.FETCH_SUMMARY_PEOPLE_SUCCESS:
            return {
                ...state,
                summaryPeople: {
                    data: action.payload,
                    error: null,
                    loading: false
                }
            };
        case SummaryActionType.FETCH_SUMMARY_PEOPLE_FAILURE:
            return {
                ...state,
                summaryPeople: {
                    data: null,
                    error: action.payload,
                    loading: false
                }
            };
        case SummaryActionType.FETCH_SUMMARY_POLICIES:
            return {
                ...state,
                summaryPolicies: {
                    data: null,
                    error: null,
                    loading: true
                }
            };
        case SummaryActionType.FETCH_SUMMARY_POLICIES_SUCCESS:
            return {
                ...state,
                summaryPolicies: {
                    data: action.payload,
                    error: null,
                    loading: false
                }
            };
        case SummaryActionType.FETCH_SUMMARY_POLICIES_FAILURE:
            return {
                ...state,
                summaryPolicies: {
                    data: null,
                    error: action.payload,
                    loading: false
                }
            };
        default:
            return state;
    }
}